export default __webpack_public_path__ + "media/zurb/img/home/Pure Storage-2347d66ea4b8893d5ba9f1ead06ea409.svg";